import { LiveStreamAuctionApi } from '../../generated/api';
import configuration from './configuration';

export default new LiveStreamAuctionApi(configuration);
